import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { DayOfWeek } from './Enums'
/**
* Class WarehouseWorkingDay
*  Один день режима работы. У рабочего дня заданы обе границы, у выходного — ни одной.
*/
export class WarehouseWorkingDay extends ActiveModel {

  /**
  * day
  * День недели.  *   * - `Sunday` Sunday  * - `Monday` Monday  * - `Tuesday` Tuesday  * - `Wednesday` Wednesday  * - `Thursday` Thursday  * - `Friday` Friday  * - `Saturday` Saturday  *   */
  @ActiveField(DayOfWeek.SUNDAY)
  day: DayOfWeek = DayOfWeek.SUNDAY


  /**
  * dayOff
  * Выходной: границы не заданы.  */
  @ActiveField(false)
  dayOff: boolean = false


/**
  * opensAt
  * Время открытия.
  */
  @ActiveField()
  opensAt?: null | string


/**
  * closesAt
  * Время закрытия.
  */
  @ActiveField()
  closesAt?: null | string
}
